//cursor
$(function () {
  var cursor = $('#cursorViewmore');
  $(document).on('mousemove', function (e) {
    var x = e.clientX;
    var y = e.clientY;
    cursor.css({
      opacity: '1',
      top: y + 'px',
      left: x + 'px',
    });
  });
  $('a, input[type="submit"] , button[type="button"]').on({
    mouseenter: function () {
      cursor.addClass('active');
    },
    mouseleave: function () {
      cursor.removeClass('active');
    },
  });
});
//scroll animation
let fadeInTarget = document.querySelectorAll('.fadeIn');
window.addEventListener('scroll', () => {
  for (let i = 0; i < fadeInTarget.length; i++) {
    const rect = fadeInTarget[i].getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;
    if (scroll > offset - windowHeight + 135) {
      fadeInTarget[i].classList.add('is-show');
    }
  }
});
//ranking slider
$(function () {
  function checkBreakPoint() {
    w = $(window).width();
    if (w <= 450) {
      $('.rankSlider').not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        autoplay: true,
        infinite: true,
        fade: true,
        autoplaySpeed: 6000,
      });
    } else {
      $('.rankSlider.slick-initialized').slick('unslick');
    }
  }
  $(window).resize(function () {
    checkBreakPoint();
  });
  checkBreakPoint();
});
